function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.574 42.876v35.688",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 59.178c0-9.517 7.05-12.483 10.574-12.777v29.52C5.582 75.92 2.028 82.677 1 86.054V59.178z",
  fill: "url(#icon2_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.337 75.92C6.523 75.92 1 81.445 1 88.258c0 6.814 5.523 12.337 12.337 12.337H90V53.451H57.837m-40.094 0h33.044",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.337 45.96C6.523 45.96 1 51.484 1 58.297v30.842M39.448 22.341l-4.373 2.525L57.808 64.24l4.711 3.111-.338-5.635L39.448 22.34z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M63.27 59.326a7.023 7.023 0 01-3.158 3.857 7.023 7.023 0 01-4.919.806",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 81.188,
  y: 60.059,
  width: 33.926,
  height: 4.406,
  rx: 2.203,
  transform: "rotate(90 81.188 60.06)",
  fill: "url(#icon2_svg__paint1_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 72.376,
  y: 60.059,
  width: 33.926,
  height: 4.406,
  rx: 2.203,
  transform: "rotate(90 72.376 60.06)",
  fill: "url(#icon2_svg__paint2_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon2_svg__paint0_linear",
  x1: 6.287,
  y1: 93.765,
  x2: 6.289,
  y2: 39.792,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon2_svg__paint1_linear",
  x1: 81.188,
  y1: 62.262,
  x2: 119.637,
  y2: 62.262,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon2_svg__paint2_linear",
  x1: 72.376,
  y1: 62.262,
  x2: 110.825,
  y2: 62.262,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.917,
  stopColor: "#fff",
  stopOpacity: 0
})));

function SvgIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default "data:image/svg+xml;base64,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";
export { SvgIcon2 as ReactComponent };